import { request } from '@services'
import { loadScript } from '@utils/loadScript'

export const state = {
  currentUser: null,
  loginLoading: false,
  error: null,
  captcha: {},

  loadingForgot: false,
  dataForgot: null,
  errorsForgot: null,
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.loginLoading = false
    state.currentUser = newValue
    state.error = null
  },
  SET_LOGIN_REQUESTED(state) {
    state.loginLoading = true
  },
  SET_LOGIN_ERROR(state, newValue) {
    state.loginLoading = false
    state.error = newValue
  },
  SET_CURRENT_SITE_KEYS(state, newValue) {
    state.captcha = newValue
    state.error = null
  },

  SET_FORGOT_REQUESTED(state) {
    state.loadingForgot = true
  },
  SET_FORGOT_RECEIVED(state, newData) {
    state.loadingForgot = false
    state.dataForgot = newData
    state.errorsForgot = null
  },
  SET_FORGOT_RECEIVED_FAILED(state, error) {
    state.loadingForgot = false
    state.errorsForgot = error
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
  getCurrentUser(state) {
    return state.currentUser
  },
  getError(state) {
    return state.error
  },
  getCaptchaInfo(state) {
    return state.captcha
  },
  getRole(state) {
    return state.currentUser?.level
  },
  getForgot(state) {
    return state.dataForgot
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    // TODO
  },
  // Logs in the current user.
  async logIn(
    { commit },
    { adminName, password, agentCode = '', captchaToken = '' } = {}
  ) {
    commit('SET_LOGIN_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/login/',
        payload: {
          admin_name: adminName,
          password,
          agent_code: agentCode,
          ...(captchaToken && { 'g-recaptcha-response': captchaToken }),
        },
      })
      commit('SET_CURRENT_USER', response)
      return response
    } catch (error) {
      commit('SET_LOGIN_ERROR', error)
    }
  },

  async reCaptchaKeys({ commit }) {
    const response = await request({
      endpoint: '/cms/login/recaptcha_keys/',
      payload: {},
    })
    const siteKey = response?.site_key
    if (response.enable) {
      loadScript(`${process.env.VUE_APP_GOOGLE_RECAPTCHA_BASE_URL}${siteKey}`)
    }
    commit('SET_CURRENT_SITE_KEYS', response)
    return response
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
  },

  async fetchingForgot({ commit }, params) {
    commit('SET_FORGOT_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/login/forget_password/',
        payload: { ...params },
      })
      commit('SET_FORGOT_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_FORGOT_RECEIVED_FAILED', error)
    }
  },
}
